import { createAsyncThunk } from "@reduxjs/toolkit";
import routes from "@/helpers/router";
import logoutAuthApi from "@/redux/slice/auth/apis/logoutAuth";

interface LogoutPayload {
  redirectUrl?: string;
}

export default createAsyncThunk("auth/authSignOut", async (payload: LogoutPayload) => {
  const redirectUrl = payload?.redirectUrl ? payload?.redirectUrl : routes.home;
  const response = await logoutAuthApi();

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }

  window.location.href = redirectUrl;

  return response;
});
